export const nav = {
  groups: {
    userFacing: 'User-facing',
    admin: 'Admin',
    qagent: 'QAgent',
    projects: 'Projects',
    quickChats: 'Quick Chats',
  },
  items: {
    meetings: 'Meetings',
    playbooks: 'Playbooks',
    users: 'Users',
    organizations: 'Organizations',
    trialUsers: 'Trial users',
    features: 'Features',
    fileSearchStores: 'File Search Stores',
    usage: 'Usage',
    feedbackResponses: 'Feedback Responses',
    modelSettings: 'Model Settings',
    newChat: 'New Chat',
    newContract: 'New Contract',
    feedback: 'Feedback',
    installForWord: 'Install for Word',
  },
  tooltips: {
    startBlankChat: 'Start a blank chat',
    draftNewContract: 'Draft a new contract from scratch',
    createNewProject: 'Create new project',
  },
  projects: {
    none: 'No projects yet',
    createToOrganize: 'Create one to organize your work',
  },
  share: {
    menu: 'Share…',
    title: (project: string) => `Share "${project}"`,
    onlyMe: 'Only me',
    onlyMeHint: 'Nobody else can open the project.',
    organization: (org: string) => `Everyone in ${org}`,
    organizationHint: 'Every member can open the project.',
    people: 'Specific people',
    peopleHint: 'Only the people you add can open the project.',
    canEdit: 'Can edit',
    canView: 'Can view',
    canEditHint: 'Upload and remove files, link playbooks',
    canViewHint: 'Read files and start their own chats',
    addPerson: 'Add a person',
    searchPlaceholder: 'Search by name or email',
    noMatches: 'No matching members',
    nobodyYet: 'Nobody added yet.',
    remove: 'Remove',
    save: 'Save',
    cancel: 'Cancel',
    saved: 'Sharing updated',
    failed: 'Could not update sharing',
    sharedBy: (name: string) => `Shared by ${name}`,
    sharedIcon: 'Shared',
    yourOrganization: 'your organization',
    chatsStayPrivate: 'Chats stay private: each person sees only their own chats in the project.',
  },
  chats: {
    rename: 'Rename',
    renameTitle: 'Rename chat',
    save: 'Save',
    cancel: 'Cancel',
    newInProject: 'New chat in project',
    renameFailed: 'Could not rename the chat',
    none: 'No recent chats',
    startAbove: 'Start a conversation above',
    untitled: 'Untitled Chat',
    newChat: 'New Chat',
    fromEmail: 'From email',
  },
  poweredBy: 'Powered by',
  user: {
    fallbackName: 'User',
    fallbackEmail: 'user@example.com',
  },
  newProjectDialog: {
    title: 'Create New Project',
    description:
      'Create a new project to organize your documents and conversations.',
    nameLabel: 'Project Name',
    namePlaceholder: 'e.g., Acme Corp NDA Review',
    trialUsage: (used: number) => `Free trial: ${used} of 2 projects used.`,
    creating: 'Creating…',
    submit: 'Create Project',
    createFailed: 'Failed to create project',
  },
  deleteProjectDialog: {
    title: 'Delete Project',
    description: (name: string) =>
      `Are you sure you want to delete "${name}"? This will permanently remove the project and all its files.`,
    deleting: 'Deleting…',
    confirm: 'Delete',
  },
};

export type NavDict = typeof nav;
